import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { filter, map, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserInformationService } from '../user/user-information.service';
import { CurrentUserInfo } from '../user/user-information.model';
import { AuthService } from '../auth/auth.service';

export const userResolver: ResolveFn<CurrentUserInfo | null> = () => {
  const userInformationService: UserInformationService = inject(
    UserInformationService,
  );

  const authService = inject(AuthService);

  return userInformationService.getCurrentUser().pipe(
    filter((user: CurrentUserInfo | null | undefined) => !!user),
    map((user: CurrentUserInfo | null) => {
      if (!user) {
        authService.logout();
        return null;
      }

      return user;
    }),
    catchError(() => {
      authService.logout();
      return of(null);
    }),
  );
};
